import { useMemo } from 'react';
import { TableColumns } from '@veneer/core';

import { useDependencyManagerContext } from 'src/contexts/dependencyManager';

export type ExtraColumnDef = {
  id: string;
  localeKeySuffix: string;
};

export function useSharedTableColumns(
  tableKey: string,
  extraColumnDefs: ExtraColumnDef[] = [],
  sortableColumnIds: string[] = []
): TableColumns[] {
  const { translate } = useDependencyManagerContext();
  const extraColumnsKey = extraColumnDefs.map((c) => c.id).join(',');
  const sortableColumnsKey = sortableColumnIds.join(',');

  return useMemo(
    () => [
      { id: 'spacer', label: '' },
      {
        id: 'deviceName',
        label: translate(`components.${tableKey}.columns.device-name`),
        ...(sortableColumnIds.includes('deviceName') && { sortable: true })
      },
      {
        id: 'deviceImage',
        label: translate(`components.${tableKey}.columns.device-image`),
        sortable: false
      },
      {
        id: 'serialNumber',
        label: translate(`components.${tableKey}.columns.serial-number`),
        ...(sortableColumnIds.includes('serialNumber') && { sortable: true })
      },
      ...extraColumnDefs.map(({ id, localeKeySuffix }) => ({
        id,
        label: translate(`components.${tableKey}.${localeKeySuffix}`),
        ...(sortableColumnIds.includes(id) && { sortable: true })
      })),
      {
        id: 'accessRemaining',
        label: translate(`components.${tableKey}.columns.access-remaining`),
        ...(sortableColumnIds.includes('accessRemaining') && { sortable: true })
      },
      {
        id: 'action',
        label: translate(`components.${tableKey}.columns.action`),
        sortable: false
      }
    ],
    [translate, tableKey, extraColumnsKey, sortableColumnsKey]
  );
}
